import React from 'react';
import { StoreTypeEnum } from '@goparrot/store-v2-sdk';
import { IconCentralLocationMono, IconCopy, IconOrganization, IconStore } from '@goparrot-dashboard/shared-ui';

type NavBarStoreIconProps = {
  storeType: StoreTypeEnum;
  isCentralLocation: boolean;
};
const ICON_SIZE = 20;
const SquareNavBarStoreIcon: React.FC<NavBarStoreIconProps> = ({ storeType, isCentralLocation }) => {
  return (
    <span className="tw-w-6 tw-flex tw-align-center tw-justify-center tw-font-normal tw-mr-2 tw-ml-2 tw-rounded-sm">
      {storeType === StoreTypeEnum.MERCHANT && <IconOrganization width={ICON_SIZE} height={ICON_SIZE} />}
      {storeType === StoreTypeEnum.STORE && (
        <span className="tw-flex">
          {isCentralLocation ? <IconCentralLocationMono width={ICON_SIZE} height={ICON_SIZE} /> : <IconStore width={ICON_SIZE} height={ICON_SIZE} />}
        </span>
      )}
      {storeType === StoreTypeEnum.DEFAULT && <IconCopy width={ICON_SIZE} height={ICON_SIZE} />}
    </span>
  );
};

export default SquareNavBarStoreIcon;
